import { useState } from "react";
import { Dialog, DialogContent, DialogTitle, TextField, Button } from "@mui/material"

const PopAddEditModelHistory = ({year, onAddYear, onCloseYear}) => {

    const [yr, setYr] = useState();


    const onChangeYear = (e) => {
        setYr(e.target.value)
    }


    return (
        <Dialog open={true} fullWidth={true} maxWidth="sm">
            <DialogTitle>History</DialogTitle>
            <DialogContent>
                <div className="flex flex-col gap-4">
                    <TextField type="number" value={yr} onChange={onChangeYear} label="Year" variant="outlined" fullWidth={true}/>
                    <div className="flex gap-4 justify-end">
                        <Button variant="contained" color="primary" onClick={() => onAddYear(yr)}>Save</Button>
                        <Button variant="contained" color="error" onClick={onCloseYear}>Close</Button>
                    </div>
                </div>

            </DialogContent>
        </Dialog>
    )
}

export default PopAddEditModelHistory;